var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"ws-info-color",style:([{'background-color':_vm.value}])}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }